module.exports = __webpack_public_path__ + "static/media/15-10.10ef979a.mp3";